import { toBoolean } from '../forms/prettifyField';
import { sanitizeCalul } from '../number/sanitizeCalul';
import { GET_FRAIS_PORT } from '../../domain/commande/getFraisPort';

export const TOTAL_COMMANDE_A_PAYER = (
  totalPanier: number,
  livraisonhorslycee: boolean,
  customerContributedToTheOng: boolean
) => {
  if (typeof livraisonhorslycee !== 'boolean')
    livraisonhorslycee = toBoolean(livraisonhorslycee);
  const amountOfNgoContribution = customerContributedToTheOng ? 1 : 0;
  return sanitizeCalul(
    totalPanier +
      amountOfNgoContribution +
      GET_FRAIS_PORT(totalPanier, livraisonhorslycee)
  );
};
